import { FC } from "react";
import PageSection from "../../parts/StaticPageSection";
import { Helmet } from "react-helmet";
import { LecalSection } from "../../parts/LecalSection";

export const ContactPage: FC = () => {
  return <>
    <Helmet>
      <title>Drop AIへのお問い合わせ - Drop AI</title>
      <meta name="description" content="Drop AIへのお問い合わせ" />
      <script src="https://sdk.form.run/js/v2/embed.js"></script>

      <meta property="og:url" content="https://drop4i.com/contact" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="お問い合わせ - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="Drop AIのお問い合わせページです。" />
    </Helmet>
    <div
      className="formrun-embed"
      data-formrun-form="@dropai"
      data-formrun-redirect="true">
    </div>
  </>;
}